"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonRichText = require("@mmc/common-rich-text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = require("./constructed-form.props/constructed-form.propTypes");
/* eslint jsx-a11y/label-has-associated-control: 0 */

/**
 * ## Checkboxes - component
 *
 * Some really cool piece of description goes here.
 */

// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var generateRandomNumber = function generateRandomNumber() {
  return Math.floor(Math.random() * 999);
};
var toggleCheckbox = function toggleCheckbox(currentState, selectedCheckbox) {
  if (currentState.indexOf(selectedCheckbox) >= 0) {
    return currentState.filter(function (el) {
      return el !== selectedCheckbox;
    });
  }
  return [].concat(currentState, [selectedCheckbox]);
};
var isSameArray = function isSameArray(xs, ys) {
  return xs.length === ys.length ? xs.filter(function (x, i) {
    return x !== ys[i];
  }).length === 0 : false;
};
var Checkboxes = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Checkboxes, _React$Component);
  function Checkboxes(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: []
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  Checkboxes.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!isSameArray(props.value, state.value)) {
      return {
        value: [].concat(props.value)
      };
    }
    return null; // No change to state
  };
  var _proto = Checkboxes.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      errorMessages = _this$props.errorMessages,
      value = _this$props.value;
    return !isSameArray(nextProps.value, value) || !isSameArray(nextProps.errorMessages, errorMessages);
  };
  _proto.handleChange = function handleChange(e, fieldName) {
    var _this$props2 = this.props,
      handleFieldChange = _this$props2.handleFieldChange,
      handleFieldBlur = _this$props2.handleFieldBlur,
      checkRequired = _this$props2.checkRequired,
      updateErrors = _this$props2.updateErrors,
      data = _this$props2.data,
      id = _this$props2.id;
    var value = this.state.value;
    e.persist(); // We need to presist the event because we're using functional setState, it is asyncronous and therefore won't have access to event after this handler has been called unless we persist the event
    var newCheckList = toggleCheckbox(value, e.target.value);
    this.setState(function () {
      return {
        value: newCheckList
      };
    });
    handleFieldChange(id, [].concat(newCheckList), fieldName);
    var required = checkRequired(newCheckList, data.isRequired);
    updateErrors(id, [required]);
    if (handleFieldBlur) {
      handleFieldBlur(e.target.value, id, [required]);
    }
  };
  _proto.render = function render() {
    var _this2 = this,
      _clsx;
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      errorMessages = _this$props3.errorMessages,
      id = _this$props3.id,
      data = _this$props3.data,
      backgroundColour = _this$props3.backgroundColour,
      isCaNewsLetterSignUp = _this$props3.isCaNewsLetterSignUp;
    var valueState = this.state.value;
    var fieldName = data.fieldName,
      fieldLabel = data.fieldLabel,
      requiredMessage = data.requiredMessage,
      options = data.options,
      choiceFieldType = data.choiceFieldType,
      fieldLongDescription = data.fieldLongDescription,
      isRequired = data.isRequired;
    var errors = errorMessages.filter(function (error) {
      return error !== '';
    });
    var orderInputBeforeText = function orderInputBeforeText() {
      var textLastList = ['personal-data-utilization'];
      return textLastList.find(fieldName);
    };
    var renderInsideChecks = function renderInsideChecks() {
      if (fieldLongDescription && options && !orderInputBeforeText) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _constructedForm["default"].checkCopy
      }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        format: "legal",
        html: handleNestedProp(fieldLongDescription, 'fieldLongDescription.text')
      })), options.map(function (option) {
        // eslint-disable-next-line
        var inputId = generateRandomNumber();
        var optionId = fieldName + "-" + option.key + "-" + inputId;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _constructedForm["default"].optionField,
          key: fieldName + "-" + option.key
        }, /*#__PURE__*/_react["default"].createElement("input", {
          className: "" + _constructedForm["default"].optionInput,
          type: choiceFieldType,
          name: fieldName + "-" + option.key,
          id: optionId,
          checked: valueState.indexOf(option.key) >= 0,
          required: isRequired,
          value: option.key,
          disabled: option.disabled,
          onChange: function onChange(e) {
            return _this2.handleChange(e, fieldName);
          }
        }), /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: optionId,
          className: _constructedForm["default"].optionLabel + " " + theme.inputsAndOptions
        }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
          theme: theme,
          html: option.label
        })));
      }));
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, options.map(function (option) {
        var inputId = generateRandomNumber();
        var optionId = fieldName + "-" + option.key + "-" + inputId;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _constructedForm["default"].optionField,
          key: fieldName + "-" + option.key
        }, /*#__PURE__*/_react["default"].createElement("input", {
          className: "" + _constructedForm["default"].optionInput,
          type: choiceFieldType,
          name: fieldName + "-" + option.key,
          id: optionId,
          checked: valueState.indexOf(option.key) >= 0,
          required: isRequired,
          value: option.key,
          disabled: option.disabled,
          onChange: function onChange(e) {
            return _this2.handleChange(e, fieldName);
          }
        }), /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: optionId,
          className: _constructedForm["default"].optionLabel + " " + theme.inputsAndOptions
        }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
          theme: theme,
          html: option.label,
          className: backgroundColour === 'dark' ? _constructedForm["default"].lightText : ''
        })));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _constructedForm["default"].checkCopy
      }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        format: "legal",
        html: handleNestedProp(fieldLongDescription, 'fieldLongDescription.text'),
        className: backgroundColour === 'dark' ? _constructedForm["default"].lightText : ''
      })));
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])((_clsx = {}, _clsx[_constructedForm["default"].formField] = !isCaNewsLetterSignUp, _clsx[_constructedForm["default"].topMargin] = isCaNewsLetterSignUp, _clsx)),
      key: fieldName
    }, /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: _constructedForm["default"].optionSet,
      "aria-describedby": errors.length !== 0 && fieldName + "-error-" + id.join('-')
    }, fieldLabel && /*#__PURE__*/_react["default"].createElement("legend", {
      className: _constructedForm["default"].fieldLabel + " " + theme.labelSmall
    }, fieldLabel && fieldLabel.trim(), isRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), renderInsideChecks(), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      role: "alert",
      errorLabel: fieldName + "-error-" + id.join('-')
    }) : errorMessages.map(function (message) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: generateRandomNumber(),
        message: message,
        theme: theme,
        errorLabel: fieldName + "-error-" + id.join('-'),
        role: "alert"
      });
    })));
  };
  return Checkboxes;
}(_react["default"].Component);
exports["default"] = Checkboxes;
Checkboxes.displayName = 'Checkboxes';
Checkboxes.defaultProps = {
  data: _constructedForm2["default"].formComponents[3],
  // eslint-disable-line
  theme: {}
};